import { createAction } from "@reduxjs/toolkit";
import { PlayerTag } from "../../logic/GameState";


export const playerConnected = createAction<PlayerTag>("playerConnected");
export const playerDisconnected = createAction<PlayerTag>("playerDisconnected");
